import { HELLO_AT_MARBLE_EMAIL } from "@marble/core/clients/sendgrid/constants";

/** Zoom caps webinar/meeting `agenda` at 2000 characters. */
export const ZOOM_AGENDA_MAX_LENGTH = 2000;

/**
 * Zoom account every Event webinar/meeting is created under. Workshop
 * Hosts are alternative hosts on that session; they never own it.
 */
export const EVENT_ZOOM_OWNER_EMAIL = HELLO_AT_MARBLE_EMAIL;

/** Display name Zoom sees for the hello@ webinar panelist. */
export const EVENT_ZOOM_OWNER_NAME = "Marble Health";

/**
 * Prefix of the transient `Event.zoomId` claim held between taking the
 * row and Zoom responding. The stored value is `__pending__:<epochMs>` so
 * a crash after the claim can expire it; a bare `__pending__` is treated
 * as already expired (legacy in-flight claims with no timestamp).
 */
export const ZOOM_SESSION_PENDING_PREFIX = "__pending__";

/** How long a Zoom create claim blocks retries before it is stealable. */
export const ZOOM_SESSION_CLAIM_TTL_MS = 2 * 60 * 1000;

/**
 * Prefix of the transient `Participant.zoomRegistrantId` claim held
 * between taking the row and Zoom responding. The stored value is
 * `CLAIMING:<epochMs>` so a crash after the claim can expire it; a
 * bare `CLAIMING` is treated as already expired (legacy in-flight
 * claims with no timestamp).
 */
export const ZOOM_REGISTRATION_CLAIM_PREFIX = "CLAIMING";

/** How long a Zoom registrant POST claim blocks retries before it is stealable. */
export const ZOOM_REGISTRATION_CLAIM_TTL_MS = ZOOM_SESSION_CLAIM_TTL_MS;

/** User-facing: drafts may only be published when the start is still upcoming. */
export const EVENT_PUBLISH_FUTURE_DATE_ERROR =
  "Workshops can only be published if the date and time are in the future.";

/**
 * HMAC scope for private workshop registration links. Shared by the
 * registration page, the seed script, and the calendar link in reminder
 * emails so a private event's token matches everywhere.
 */
export const EVENT_REGISTRATION_TOKEN_PURPOSE = "EVENT_REGISTRATION";

/** 12 hex chars (48 bits) is enough to gate a registration page. */
export const EVENT_REGISTRATION_TOKEN_LENGTH = 12;

/**
 * HMAC scope for the public recording page. Shared by the recording
 * gate, counselor Past View, follow-up emails, and the seed script so
 * one token opens `/events/:id/recording`.
 */
export const EVENT_RECORDING_SHARE_TOKEN_PURPOSE = "EVENT_RECORDING_SHARE";

/** 16 hex chars; the form gate still runs after this link is opened. */
export const EVENT_RECORDING_SHARE_TOKEN_LENGTH = 16;
